import { render, staticRenderFns } from "./priceListComponent.vue?vue&type=template&id=0661fc2f&"
import script from "./priceListComponent.vue?vue&type=script&lang=js&"
export * from "./priceListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports